import { AxiosError } from "axios";

import { DomainError, DomainErrorDTO } from "shared";

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly responseBody: unknown,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export type ApiErrorBody = {
  body: string;
  message: string;
  path: string;
  status: number;
  statusCode: number;
  timestamp: string;
  domainException?: DomainErrorDTO;
};
export type ApiErrorBodyWithDomainException = ApiErrorBody & {
  domainException: DomainErrorDTO;
};

export function containsDomainError(body: unknown): body is ApiErrorBodyWithDomainException {
  return Boolean(body && typeof body === "object" && (body as ApiErrorBody).domainException);
}

function extractAxiosDomainError(error: unknown): DomainError | null {
  if (!(error instanceof AxiosError)) {
    return null;
  }

  if (!containsDomainError(error.response?.data)) {
    return null;
  }

  const rawDomainError = error.response.data.domainException;

  return DomainError.fromJson(rawDomainError);
}

export function extractDomainError(error: unknown): DomainError | null {
  // AxiosError are returned when using the legacy fetcher
  const axiosError = extractAxiosDomainError(error);
  if (axiosError) {
    return axiosError;
  }

  // Error within the body are returned when using the new api fetcher using @ts-rest/react-query
  if (containsDomainError(error)) {
    return DomainError.fromJson(error.domainException);
  }

  return null;
}
